import { z } from "zod";

/**
 * Zod Validation Schemas
 * Defines the structure and validation rules for all forms and API requests.
 */

/**
 * Booking Schema
 * Used for the appointment form everywhere on the site (public + manual
 * dashboard entry). One Name field — not split into first/last — because
 * the Patient record itself only stores a single name.
 */
export const bookingSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name is too long"),
  age: z.string().min(1, "Please select age"),
  gender: z.string().min(1, "Please select gender"),
  phone: z
    .string()
    .min(10, "Phone number must be at least 10 digits")
    .max(16, "Phone number is too long"),
  countryCode: z.string().optional(),
  service: z.string().optional(),
  preferredDate: z.string().min(1, "Please select a date"),
  preferredTime: z.string().min(1, "Please select a time"),
});
export type BookingFormData = z.infer<typeof bookingSchema>;

/**
 * Combined Booking Schema
 * Kept as a separate export name since app/api/bookings/route.ts imports it
 * specifically — same shape as bookingSchema.
 */
export const combinedBookingSchema = bookingSchema;
export type CombinedBookingFormData = z.infer<typeof combinedBookingSchema>;

/**
 * Login Schema
 * Used for staff authentication.
 */
export const loginSchema = z.object({
  email: z.string().email("Please enter a valid email"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});
export type LoginFormData = z.infer<typeof loginSchema>;
